module.exports = __webpack_public_path__ + "static/media/email-icon.06436501.svg";